module.exports='<div ui-view=""></div>';